// extracted by mini-css-extract-plugin
export default {"container":"InstanceWaitingRoomPage_container__Rcvxz","header":"InstanceWaitingRoomPage_header__mo24x","content":"InstanceWaitingRoomPage_content__eJmBk"};